
const styles = {
  calloutContainer: 'character-recruitment-preview--calloutContainer'
};

export function RecruitmentProfilePreviewCallout(props: any) {
  return (
    <div className={`${props.className} ${styles.calloutContainer}`}>
      <b>
        <div className={'slds-text-body--medium'}>{props.value}</div>
      </b>
      <div className={'slds-text-body--small text-muted'}>{props.label}</div>
    </div>
  );
}
